import { graphql } from "@/graphql";

export const createSupplyChainBooking = graphql(`
  mutation CreateBooking($input: CreateSupplyChainBookingInput!) {
    createSupplyChainBooking(input: $input) {
      errors {
        field
        messages
      }
      supplyChainBooking {
        id
        name
        plannedShippingDate
        note
        numberOfHead
        status
        destination {
          id
        }
        source {
          id
        }
      }
    }
  }
`);
